import { Injectable, Optional, SkipSelf } from '@angular/core';
import { AppFacadeService } from '@smarsh-cyber/app-state';
import { isAuthenticated, isCutOverClient } from '@smarsh-cyber/shared/utils';
import { NgxPermissionsService } from 'ngx-permissions';
import { CHART_FIRM_SERVER_URL, CHART_PORTAL } from '../../app.constants';
import { IAppConfiguration } from '../interfaces/AppConfiguration';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService implements IAppConfiguration {
  portalName: string = '';
  portalUrl: string = '';
  code: string = '';
  redirectUri: string = '';
  REFRESH_TOKEN_TIMER = 45 * 60 * 1000;

  constructor(
    private appfacade: AppFacadeService,
    private ngxPermissionsService: NgxPermissionsService,
    @Optional() @SkipSelf() parentService: AppConfigService
  ) {
    if (parentService) {
      throw new Error('AppConfigService is already loaded.');
    }
  }

  setPortal() {
    const url: URL = new URL(location.href.replace('/#', ''));
    //example of URL - https://lpl.cyber.smarsh.com
    let portalName: string = url.hostname.split('.')[0] ?? '';

    //For local development use portalName from query param
    portalName = url.searchParams.get('portalName') ?? portalName;

    const portalURL = CHART_FIRM_SERVER_URL;

    this.code = url.searchParams.get('code') ?? '';

    if (portalName) {
      this.portalName = portalName;
      this.portalUrl = portalURL.replace(CHART_PORTAL, this.portalName);
    }

    url.searchParams.delete('code');
    let href = url.href;
    if (url.pathname === '/') {
      href = href.replace(/(?:\/)(\?|$)/, '$1');
    }
    this.redirectUri = href;
    sessionStorage.setItem('redirectUri', this.redirectUri);
    this.appfacade.setPortalDetails(this.portalName, this.portalUrl);
  }

  init(): Promise<boolean> {
    this.setPortal();
    return new Promise((resolve) => {
      if (
        this.portalName &&
        isAuthenticated(this.portalName, !isCutOverClient(this.portalName))
      ) {
        this.appfacade.init(this.portalName, this.code, this.portalUrl);
        this.appfacade.$isError.subscribe({
          next: (res) => {
            if (res) {
              resolve(false);
            }
          }
        });

        this.appfacade.$isLoaded.subscribe({
          next: (res) => {
            if (res) {
              this.ngxPermissionsService.loadPermissions(
                this.appfacade?.$userDetails().permissions
              );
              this.intialize();
              resolve(true);
            }
          }
        });
      } else {
        this.appfacade.appLoadFailure();
        resolve(false);
      }
    });
  }

  intialize() {
    if (this.appfacade.tokenRefreshInterval)
      clearInterval(this.appfacade.tokenRefreshInterval);
    this.appfacade.tokenRefreshInterval = setInterval(() => {
      this.appfacade.refreshToken();
    }, this.REFRESH_TOKEN_TIMER);
  }
}
